
import {of as observableOf, Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {CommonService} from '../../common/controller/common.service';
import {ApiMessageService} from '../../core/api-message.service';
import {Ruolo} from './ruolo.model';
import {Router} from '@angular/router';
import {JsonBaseBuilder} from '../../common/builder/json-base-builder';
import {ConfigService} from '../../core/config.service';
import {Table} from '../../common/model/table.model';
import {MODULE_CONFIGURAZIONE} from '../../app-routing.module';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class RuoloService extends CommonService<Ruolo> {

  public static ROUTE = 'ruolo';

  public constructor(protected httpClient: HttpClient,
                     protected apiMessageService: ApiMessageService,
                     protected router: Router,
                     protected configService: ConfigService,
                     protected translateService: TranslateService) {
    super(httpClient, apiMessageService, router, configService);
  }

  public buildInstance(json: any): Ruolo {
    return JsonBaseBuilder.jsonToRuolo(json);
  }

  public getModule(): string {
    return MODULE_CONFIGURAZIONE;
  }

  public getApiService(): string {
    return ConfigService.ACE;
  }

  public getRoute(): string {
    return RuoloService.ROUTE;
  }

  public existingDescr(descr: string, entity: Ruolo): Observable<boolean> {
    return this.getBoolean('/existingdescr', new HttpParams()
      .set('descr', descr)
      .set('id', entity?.getId() ? entity?.getId() + '' : ''));
  }

  public existingSigla(sigla: string, entity: Ruolo): Observable<boolean> {
    return this.getBoolean('/existingsigla', new HttpParams()
      .set('sigla', sigla)
      .set('id', entity?.getId() ? entity?.getId() + '' : ''));
  }

  public activeByUsername(username: string): Observable<Ruolo[]> {
    return this.getArray('/ruoliattivi/' + username, new HttpParams());
  }

  public permittedForUrl(urls: string): Observable<Ruolo[]> {
    return observableOf([]);
  }

  public getTable(items: Ruolo[]): Table {
    return Table.buildBaseTable(Ruolo.getTableKeys(), items, this.translateService);
  }

  public byContesto(contestoId: number): Observable<Ruolo[]> {
    return this.getAll({ 'contestoId': contestoId});
  }

  public byTipoEntitaOrganizzativa(tipoEntitaOrganizzativaId: number): Observable<Ruolo[]> {
    return this.getAll({ 'tipoEntitaOrganizzativaId': tipoEntitaOrganizzativaId});
  }

  public getRuoliDelegabili(): Observable<Ruolo[]> {
    return this.getArray('/ruolidelegabili', new HttpParams());
  }

  public isSuperUtente(): Observable<boolean> {
    return this.getBoolean('/isSuperUtente', new HttpParams());
  }

  public getRuoliAssegnati(sigla: string): Observable<Ruolo[]> {
    return this.getArray('/ruoliassegnati', new HttpParams()
      .set('siglaRuolo', sigla));
  }
}
